import { gql } from '@apollo/client'
import PHYSICAL_FORM_FRAGMENT from 'apollo/fragments/PHYSICAL_FORM_FRAGMENT'

// ANNUAL_PHYSICAL_INPUTS

export default gql`
  query annualPhysicalInputs {
    input_annual_physical_form {
      mammogram {
        ...PHYSICAL_FORM_FRAGMENT
      }
      pap_smear {
        ...PHYSICAL_FORM_FRAGMENT
      }
      patient_name {
        ...PHYSICAL_FORM_FRAGMENT
      }
      prostate_screening {
        ...PHYSICAL_FORM_FRAGMENT
      }
      colon_screening {
        ...PHYSICAL_FORM_FRAGMENT
      }
      smoking_attestation {
        ...PHYSICAL_FORM_FRAGMENT
      }
    }
  }
  ${PHYSICAL_FORM_FRAGMENT}
`
